import { EditPenIcon, InfoIcon } from '@sharedCR/coreDesignSystem/icons';

import { FieldInputType } from 'constants/fields';
import { ItemGroupAlignment } from 'constants/ui';

export const notesViewConfigFields = {
  underwritingManualNotes: {
    name: 'underwritingManualNotes',
    contentLabelClassName: 'w-full truncate',
    contentValueClassName: 'whitespace-pre-line',
    type: FieldInputType.RICH_TEXT,
    isValueTooltip: false,
  },
};

export const getNotesViewConfig = ({ onEdit, isEditAllowed, isLoading }) => {
  return {
    name: 'Notes',
    icon: InfoIcon,
    methods: {
      edit: {
        name: 'Edit',
        icon: EditPenIcon,
        onClick: isEditAllowed ? onEdit : undefined,
        disabled: isLoading,
      },
    },
    content: [
      {
        groupsAlignment: ItemGroupAlignment.VERTICAL,
        groups: [[notesViewConfigFields.underwritingManualNotes]],
      },
    ],
  };
};
